export const getDefaultState = () => {
	return {
		reportForm: {},
		generalData: {},
		isLoadedGeneralData: false
	};
};

export default getDefaultState();
